import { gql } from 'core/dna/types/apollo';

export const EDIT_LESSON_GROUP_MUTATION = gql`
  mutation editLessonGroup($input: EditLessonGroupInput!) {
    editLessonGroup(input: $input) {
      id
    }
  }
`;
